<template>
  <article class="hc-record-card">
    <header v-if="title || badge || $slots.actions" class="hc-record-card__head">
      <div class="hc-record-card__head-text">
        <h4 v-if="title" class="hc-record-card__title">{{ title }}</h4>
        <p v-if="subtitle" class="hc-record-card__subtitle">{{ subtitle }}</p>
      </div>
      <span v-if="badge" class="hc-record-card__badge">{{ badge }}</span>
      <div v-if="$slots.actions" class="hc-record-card__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="hc-record-card__body">
      <slot />
    </div>
  </article>
</template>

<script>
export default {
  name: 'ProfileRecordCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    badge: { type: String, default: '' },
  },
};
</script>
